import { useState } from "react";

import { Box, Stack } from "@mui/material";
import { Grid } from "@mui/system";

import Fsk8sUpsellGuard from "../../Upsell/Fsk8sUpsellGuard";
import { TimeRange } from "../ClusterDetail/Components/TimeRangeSelector";
import Fsk8sBanner from "./Banner";
import ClusterCostChart from "./ClusterCostChart";
import { Fsk8sHeader } from "./Header";
import { Fsk8sOverviewDashboard } from "./OverviewDashboard";
import { Fsk8sClusterTable } from "./Table";
import { ClusterDashboardContextProvider } from "./Table/context";

const Fsk8sPage = () => {
  const [timeRange, setTimeRange] = useState(TimeRange.T_30D);

  return (
    <Fsk8sUpsellGuard>
      <ClusterDashboardContextProvider timeRange={timeRange}>
        <Box mt={2}>
          <Stack spacing={2}>
            <Fsk8sHeader timeRange={timeRange} onChangeTimeRange={setTimeRange} />
            <Stack spacing={3}>
              <Fsk8sOverviewDashboard />
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                  }}
                >
                  <ClusterCostChart />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                  }}
                >
                  <Fsk8sBanner />
                </Grid>
              </Grid>
              <Fsk8sClusterTable />
            </Stack>
          </Stack>
        </Box>
      </ClusterDashboardContextProvider>
    </Fsk8sUpsellGuard>
  );
};

export default Fsk8sPage;
